import { React, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import Cookies from "js-cookie";

import DesktopHeader from "./headerTypes/desktopHeaders/DesktopHeader";
import ModileHeader from "./headerTypes/mobileHeaders/ModileHeader";

import { useWindowDimensions } from "./../../../hooks";

import { get_user_info } from "../../../redux/features/userSlice";

import "./header.scss";

function Header() {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  let location = useLocation();

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    dispatch(get_user_info()).then((result) => {
      setUserInfo(result?.payload);
    });
  }, [dispatch, location]);

  
  const point_earned = Cookies.get("point_earned");
  useEffect(() => {
    if (point_earned && point_earned !== "false") {
      let audio = new Audio(
        "https://production-blue-manor-static.s3.us-east-2.amazonaws.com/audio/coin_sound_effect.mp3"
      );
      audio.volume = 0.5;
      audio.play();

      setTimeout(() => {
        if (window.location.hostname === "localhost") {
          Cookies.set("point_earned", false, { domain: 'localhost' });
        } else if (window.location.hostname !== "localhost") {
          Cookies.set("point_earned", false, { domain: '.bluemanoracademy.com' });
        }
      }, 300);
    }
  }, [point_earned]);

  return width <= 479 ? (
    <ModileHeader userInfo={userInfo} point_earned={point_earned} />
  ) : (
    <DesktopHeader userInfo={userInfo} point_earned={point_earned} />
  );
}

export default Header;
